//const currentElement = document.getElementsByClassName('{{rootClassName}}');

        // Function to add business days to a date
        function addBusinessDays(date, days) {
            let count = 0;
            while (count < days) {
                date.setDate(date.getDate() + 1);
                let dayOfWeek = date.getDay();
                if (dayOfWeek !== 0 && dayOfWeek !== 6) {
                    count++;
                }
            }
            return date;
        }

        // Function to format a date as "25 Iunie"
        function formatDate(date) {
            const months = [
                "Ian", "Feb", "Martie", "Apr", "Mai", "Iunie",
                "Iulie", "Aug", "Sept", "Oct", "Noi", "Dec"
            ];
            return `${date.getDate()} ${months[date.getMonth()]}`;
        }

        // Function to get the time remaining until cutoff
        function getTimeUntilCutoff(cutoffHour) {
            const now = new Date();
            const cutoff = new Date();
            cutoff.setHours(cutoffHour, 0, 0, 0);
            if (now.getHours() >= cutoffHour) {
                cutoff.setDate(now.getDate() + 1);
            }
            const diff = cutoff - now;
            const hours = Math.floor(diff / (1000 * 60 * 60));
            const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
            return { hours, minutes };
        }

        // Function to get the delivery estimate message
        function getDeliveryEstimateMessage(cutoffHour) {
            const now = new Date();
            let shippingDate = new Date();

            if (now.getHours() >= cutoffHour) {
                shippingDate = addBusinessDays(shippingDate, 1);
            }

            const deliveryStartDate = addBusinessDays(new Date(shippingDate), 1);
            const deliveryEndDate = addBusinessDays(new Date(shippingDate), 4);

            const timeUntilCutoff = getTimeUntilCutoff(cutoffHour);

            return `<p>✓ <span class="in-stock">În Stoc</span> Comandă în următoarele <span class="bold">${timeUntilCutoff.hours}h ${timeUntilCutoff.minutes}m</span> și vei primi comanda între <span class="bold">${formatDate(deliveryStartDate)} - ${formatDate(deliveryEndDate)}</span></p>`;
        }

        // Set the cutoff time to 17:00 (5 PM)
        const cutoffHour = 15;

        // Get the delivery estimate message
        const deliveryEstimateMessage = getDeliveryEstimateMessage(cutoffHour);

        // Update the HTML with the delivery estimate message
        const elements = document.getElementsByClassName('delivery-estimate');
        for (let i = 0; i < elements.length; i++) {
            elements[i].innerHTML = deliveryEstimateMessage;
        }